/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PreOpsQuestionKind } from './PreOpsQuestionKind';
import {
    PreOpsQuestionKindFromJSON,
    PreOpsQuestionKindFromJSONTyped,
    PreOpsQuestionKindToJSON,
    PreOpsQuestionKindToJSONTyped,
} from './PreOpsQuestionKind';

/**
 * 
 * @export
 * @interface PreOpsQuestionUpdate
 */
export interface PreOpsQuestionUpdate {
    /**
     * 
     * @type {PreOpsQuestionKind}
     * @memberof PreOpsQuestionUpdate
     */
    kind?: PreOpsQuestionKind | null;
    /**
     * 
     * @type {string}
     * @memberof PreOpsQuestionUpdate
     */
    body?: string | null;
    /**
     * 
     * @type {number}
     * @memberof PreOpsQuestionUpdate
     */
    position?: number | null;
}



/**
 * Check if a given object implements the PreOpsQuestionUpdate interface.
 */
export function instanceOfPreOpsQuestionUpdate(value: object): value is PreOpsQuestionUpdate {
    return true;
}

export function PreOpsQuestionUpdateFromJSON(json: any): PreOpsQuestionUpdate {
    return PreOpsQuestionUpdateFromJSONTyped(json, false);
}

export function PreOpsQuestionUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): PreOpsQuestionUpdate {
    if (json == null) {
        return json;
    }
    return {
        
        'kind': json['kind'] == null ? undefined : PreOpsQuestionKindFromJSON(json['kind']),
        'body': json['body'] == null ? undefined : json['body'],
        'position': json['position'] == null ? undefined : json['position'],
    };
}

export function PreOpsQuestionUpdateToJSON(json: any): PreOpsQuestionUpdate {
    return PreOpsQuestionUpdateToJSONTyped(json, false);
}

export function PreOpsQuestionUpdateToJSONTyped(value?: PreOpsQuestionUpdate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'kind': PreOpsQuestionKindToJSON(value['kind']),
        'body': value['body'],
        'position': value['position'],
    };
}

